import { useEffect } from "react";

import CountUP from "../../includes/CountUp";

export default function SoldProductsChart({loadingState, response}) {
    useEffect(() => {}, [loadingState, response]);

    return (
        <div className="block p-6 bg-white border border-gray-200 rounded-lg shadow-sm progressbar-chart">
            <h3 className="component-heading">Top Sold Products</h3>
            { ! loadingState ? (
                response?.items?.length ? response.items.map((item, index) => (
                    <div key={`${item.title}-${index}`} class="flex items-center gap-4 mb-4">
                        <div class="flex items-center gap-3 flex-grow flex-shrink-0">
                            <div class="w-12 h-12 flex items-center justify-center">
                            <img src={item.thumb} width="40" className="rounded-md" alt={item.title} />
                            </div>
                            <div>
                            <h4 class="font-semibold" style={{ margin: '0px'}}>{item.title}</h4>
                            <p style={{ margin: '0px'}}>{item.category}</p>
                            </div>
                        </div>

                        <div class="w-1/4 h-[5px] bg-gray-200 rounded">
                            <div className={`h-full rounded transition-all duration-700 ease-out ${
                                item.value <= 25
                                ? 'bg-red-500'
                                : item.value <= 50
                                ? 'bg-yellow-500'
                                : item.value <= 75
                                ? 'bg-blue-500'
                                : 'bg-green-500'
                            }`} 
                            style={{width: item.value+'%'}}></div>
                        </div>

                        <div>
                            <p class="m-0 text-base"><CountUP end={item.value} />%</p>
                        </div>
                    </div>
                )) : (
                    <p className="text-sm text-gray-500 m-0">No data found.</p>
                )
            ) : (
                <Skeleton />
            )} 
        </div>
    );
}

function Skeleton() {
    return (
        <>
        {[...Array(5)].map((_, i) => (
            <div  key={i} role="status" class="flex items-center gap-4 mb-4 animate-pulse">
                <div class="flex items-center gap-3 flex-grow flex-shrink-0">
                    <div class="w-12 h-12 flex items-center justify-center">
                    <div class="w-10 h-10 bg-gray-200 rounded-md"></div>
                    </div>
                    <div>
                    <div class="h-3 bg-gray-200 rounded w-24 mb-2"></div>
                    <div class="h-2.5 bg-gray-200 rounded w-16"></div>
                    </div>
                </div>

                <div class="w-1/4 h-[5px] bg-gray-200 rounded overflow-hidden">
                    <div class="h-full bg-gray-300 rounded" style={{ width: (100-i*20)+'px'}}></div>
                </div>

                <div class="w-8 h-4 bg-gray-200 rounded"></div>

                <span class="sr-only">Loading...</span>
            </div>
        ))}
    </>
    );
}